import React from 'react'
import { useAppContext } from "../../context/appContext";
import { InputCheckboxButton } from "../workspace";
import { isEqual } from "lodash";

function Warranties() {
  const { warranties, warrantiesOriginal, handleArrayChange, } =
    useAppContext();

  // check warranty and create/update
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const handleInput = (e, index) => {
    const property = "warranty";
    const value = e.target.value;
    const baseArray = [...warranties];
    const baseName = "warranties";
    handleArrayChange({ baseName, baseArray, index, property, value });
  };
  const handleCheck = (value, index) => {
    const property = "useWarranty";
    // const value = e.target.checked; // grab checked instead of value
    const baseArray = [...warranties];
    const baseName = "warranties";
    handleArrayChange({ baseName, baseArray, index, property, value });
  };
  return (
    <div className="group one-third">
      <form onSubmit={handleSubmit} className="form unsaved-container">
        {!isEqual(warranties, warrantiesOriginal) && (
          <div className="unsaved-dot" title="Unsaved changes" />
        )}
        <h3>Warranties</h3>
        <div className="form-center warranties">
          {/* Loop through and display the warranties */}
          {warranties?.map((wrnty, i) => {
            return (
              <div
                key={i}
                className={
                  wrnty.useWarranty
                    ? "selected whole checkbox"
                    : "whole checkbox"
                }
              >
                <InputCheckboxButton
                  name={`warranty-desc-${i}`}
                  checkName={`include-warranty-${i}`}
                  value={wrnty.useWarranty || false}
                  textValue={wrnty.warranty || ""}
                  handleCheckboxChange={() =>
                    handleCheck(!wrnty.useWarranty, i)
                  }
                  handleTextChange={(e) => {
                    handleInput(e, i);
                  }}
                />
              </div>
            );
          })}
        </div>
      </form>
    </div>
  );
}
export default Warranties;
